import React, { Component } from 'react';

import Legend from '../components/Legend';
import MapperControl from '../components/MapperControl';

class HomePage extends Component {
  render() {
    return (
      <div className="fill">
        <div className="HomePage" style={{ margin: '0px', padding: '5px' }}>
          <Legend />
          <MapperControl
            setNumPracs={numPracs => {
              this.setState({ numPracs: numPracs });
            }}
          />
        </div>
      </div>
    );
  }
}

export default HomePage;
